/**
 * Nombres para mostrar de los códigos de bucket que guarda el historial
 * (`BucketOrigen_BAA` / `BucketDestino_BAA` y el texto de `Descripcion_BAA`):
 * los mismos que las tarjetas de Inventario. El dato guardado no cambia; sólo
 * se traduce al mostrarlo.
 */
const NOMBRES: Record<string, string> = {
  Disp: 'Disponible',
  PagoPend: 'Pago Pendiente',
  Reservado: 'Pago Pendiente',
  PagoParc: 'Pago Parcial',
  PendDesp: 'Pendiente Despacho',
  Despacho: 'Pendiente Despacho',
  PorIng: 'Por Ingresar',
  PorIngresar: 'Por Ingresar',
  PrestShow: 'Prest/Show',
  redistribucion_interna: 'Redistribución interna',
};

/** "PagoParc+Despacho" → "Pago Parcial + Pendiente Despacho"; lo desconocido queda igual. */
export function nombreBucket(codigo: string | null | undefined): string | null {
  const c = codigo?.trim();
  if (!c) return null;
  return c
    .split('+')
    .map((p) => NOMBRES[p.trim()] ?? p.trim())
    .join(' + ');
}

// Sólo palabras enteras: "Disp" no toca "Disponible".
const CODIGO_EN_TEXTO = new RegExp(`\\b(${Object.keys(NOMBRES).join('|')})\\b`, 'g');

/** Traduce los códigos que aparecen sueltos en una descripción ("Disp -1 · PagoPend +1"). */
export function textoConBuckets(texto: string): string {
  return texto.replace(CODIGO_EN_TEXTO, (c) => NOMBRES[c] ?? c);
}
